import { generateBaseStylesForTheme } from "../../styles/baseStylesGenerators";
import { theme } from "../../styles/theme";
export var BaseStyles = generateBaseStylesForTheme(theme);